import React from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';

class CodesRegister extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.save = this.save.bind(this);
        this.renderProductsOptions = this.renderProductsOptions.bind(this);
        this.renderCodes = this.renderCodes.bind(this);
        this.addCode = this.addCode.bind(this);
        //this.setFormType = this.setFormType.bind(this);

        this.state = {
            products: [],
            product: {},
            codes: [],
            tmpcodes: [],
            request: {},
            uploadType: 0,
            loading: false,
            successRegister: false
        };
    }

    componentWillMount() {
        let self = this;

        axios.get('/api/products/list/' + project)
            .then(response => {
                self.setState({
                    products: response.data
                });
            })
            .catch(error => {
            });
    }

    componentDidMount() {
        let self = this;
    }


    handleChange({target}) {
        let self = this;

        let product = self.state.product;
        product[target.id] = target.value;

        self.setState({
            product: product
        });
    }

    addCode() {
        let self = this;
        let codes = self.state.codes;
        let tmpcodes = self.state.tmpcodes;

        let number = $('#codeNumber').val();
        let pin = $('#codePin').val();

        let index = tmpcodes.includes(number);

        if (!index) {

            if (number === "") {
                swal({
                    title: "¡Oh no!",
                    text: "El código no puede estar vacío.",
                    icon: "warning",
                });
            } else {
                let code = {};
                code['number'] = number;
                code['pin'] = pin;

                codes.push(code);
                tmpcodes.push(number);

                self.setState({
                    codes: codes,
                    tmpcodes: tmpcodes
                });
            }
        } else {
            swal({
                title: "¡El código ya existe!",
                text: "El código ya ha sido agregado anteriormente.",
                icon: "warning",
            });
        }

        $('#codeNumber').val("");
        $('#codePin').val("");
    }

    removeCode(item) {
        let self = this;
        let codes = self.state.codes;
        let tmpcodes = self.state.tmpcodes;

        let index_tmpcodes = tmpcodes.indexOf(item.number);
        let index_codes = codes.indexOf(item);

        codes.splice(index_codes, 1);
        tmpcodes.splice(index_tmpcodes, 1);

        self.setState({
            codes: codes,
            tmpcodes: tmpcodes
        });
    }

    save()
    {
        let self = this;
        let request = self.state.request;

        if (!self.state.product.description || !self.state.product.id_product) {
            swal({
                title: "¡Oh no!",
                text: "Por favor, completa los campos antes de proceder.",
                icon: "warning",
            });
        } else {

            if (self.state.uploadType === 1) {
                if (self.state.codes.length > 0) {
                    request['id_product'] = self.state.product.id_product;
                    request['description'] = self.state.product.description;
                    request['codes'] = self.state.codes;

                    swal({
                        title: 'Un momento...',
                        text: 'Estamos procesando tu solicitud.',
                        buttons: false,
                        showCancelButton: false,
                        showConfirmButton: false,
                        closeOnClickOutside: false,
                    });

                    axios.post('/api/codes/register/' + project, request)
                    .then(response => {

                            let batch = response.data;

                            $('#codesRegisterButton').remove();
                            $("#codesForm :input").attr("disabled", true);

                            self.setState({
                                successRegister: true
                            });

                            swal({
                                title: "¡Lote \"" + batch.description + "\" registrado!",
                                text: "Se han registrado " + batch.total_codes + " códigos existosamente.",
                                icon: "success",
                            });
                        })
                        .catch(error => {
                            swal({
                                title: "¡Oh no!",
                                text: "Ha ocurrido un error al procesar tu solicitud.",
                                icon: "warning",
                            });
                        });
                } else {
                    swal({
                        title: "¡Oh no!",
                        text: "No has agregado códigos a tu solicitud.",
                        icon: "warning",
                    });
                }
            } else if (self.state.uploadType === 2) {
                request['id_product'] = self.state.product.id_product;
                request['description'] = self.state.product.description;
                swal({
                    title: 'Un momento...',
                    text: 'Estamos procesando tu solicitud.',
                    buttons: false,
                    showCancelButton: false,
                    showConfirmButton: false,
                    closeOnClickOutside: false,
                });

                axios.post('/api/codes/file/register/' + project, request)
                 .then(response => {

                        let batch = response.data;

                        $('#codesRegisterButton').prop('disabled', true);
                        $('#codesRegisterButton').prop('value', "Guardando");
                        $("#batchFileForm").attr("action", "/codes/file/" + batch.id);
                        $("#batchFileForm").submit();

                    })
                    .catch(error => {
                        swal({
                            title: "¡Oh no!",
                            text: "Ha ocurrido un error al procesar tu solicitud.",
                            icon: "warning",
                        });
                    });
            }

        }

        self.setState({
            loading: false
        });

        $('#codesRegisterButton').prop('value', "Guardar");

    }

    renderProductsOptions(item) {
        return (
            <option key={item.id} value={item.id}>
                {item.key}
            </option>
        );
    }

    renderCodes(item) {
        let pin = item.pin === "" ? "Sin pin registrado" : item.pin;

        return (
            <tr key={item.number}>
                <td>{item.number}</td>
                <td>{pin}</td>
                <td>
                    <button type="button" className="btn btn-danger btn-block"
                            onClick={this.removeCode.bind(this, item)}>
                        <i className="fa fa-trash-o"></i> Eliminar
                    </button>
                </td>
            </tr>
        );
    }

    setFormType(type) {
        let self = this;

        self.setState({
            uploadType: type
        });
    }

    render() {
        /*
        * <label htmlFor="codesFile">Subir archivo</label>
        * <input type="file" className="form-control" id="codesFile" disabled={true}/>
        * <br/>
        * */

        let buttonManual = this.state.uploadType === 1 ? " btn-success " : " btn-success btn-custom  ";
        let buttonFile = this.state.uploadType === 2 ? " btn-info " : " btn-info btn-custom ";

        return (
            <div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel panel-default">
                                <div className={"panel-header"}>
                                    <div className={"row"}>
                                        <div className="col-md-4 col-md-offset-4"
                                             style={{paddingTop: "25px", paddingBottom: "25px"}}>
                                            <div className="col-md-8 col-md-offset-2">
                                                <img src="../img/codes.png" className="img-responsive"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="panel-body">
                                    <div className="col-md-12">
                                        <h4 className="m-t-0 header-title"><b>Registro de Códigos</b></h4>
                                        <br/>

                                        <div className="row">
                                            <div className="col-md-2">
                                                <button className={"btn" + buttonManual + "btn-block"}
                                                        onClick={this.setFormType.bind(this, 1)}>
                                                    <i className="fa fa-keyboard-o"></i> Carga manual
                                                </button>
                                            </div>
                                            <div className="col-md-2">
                                                <button className={"btn" + buttonFile + "btn-block"}
                                                        onClick={this.setFormType.bind(this, 2)}>
                                                    <i className="fa fa-upload"></i> Carga por archivo
                                                </button>
                                            </div>
                                        </div>
                                        <hr/>
                                        <br/>
                                        {
                                            this.state.uploadType === 1 &&
                                            <form role="form" id="codesForm">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <label htmlFor="product">Producto</label>
                                                        <select className="form-control" id="id_product"
                                                                onChange={this.handleChange}>
                                                            <option value={null}>Selecciona un producto</option>
                                                            {this.state.products.map(this.renderProductsOptions)}
                                                        </select>
                                                        <br/>
                                                        <label htmlFor="codesFile">Descripción</label>
                                                        <textarea className="form-control" id="description"
                                                                  onChange={this.handleChange}/>
                                                    </div>
                                                    <div className="col-md-6 col-md-offset-1"
                                                         style={{marginTop: "-22px"}}>
                                                        <table className="table text-center">
                                                            <thead>
                                                            <tr>
                                                                <th>Código</th>
                                                                <th>Pin *</th>
                                                                <th></th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr>
                                                                <td>
                                                                    <input type="text"
                                                                           className="form-control text-center"
                                                                           id="codeNumber"/>
                                                                </td>
                                                                <td>
                                                                    <input type="text"
                                                                           className="form-control text-center"
                                                                           id="codePin"/>
                                                                </td>
                                                                <td>
                                                                    <button type="button"
                                                                            className="btn btn-info btn-block waves-effect waves-light"
                                                                            onClick={this.addCode}>
                                                                        <i className={"fa fa-plus"}></i> Agregar
                                                                    </button>
                                                                </td>

                                                            </tr>
                                                            {this.state.codes.map(this.renderCodes)}
                                                            </tbody>
                                                        </table>
                                                        <small>* - Campo NO obligatorio</small>
                                                    </div>
                                                </div>
                                            </form>
                                        }
                                        {
                                            this.state.uploadType === 2 &&
                                            <div className="row" style={{marginLeft: "0px"}}>
                                                <form role="form" id="codesFileForm">
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <label htmlFor="product">Producto</label>
                                                            <select className="form-control" id="id_product"
                                                                    onChange={this.handleChange}>
                                                                <option value={null}>Selecciona un producto</option>
                                                                {this.state.products.map(this.renderProductsOptions)}
                                                            </select>
                                                            <br/>
                                                            <label htmlFor="codesFile">Descripción</label>
                                                            <textarea className="form-control" id="description"
                                                                      onChange={this.handleChange}/>
                                                            <br/>
                                                            {
                                                                this.state.successRegister &&
                                                                <div>
                                                                    <a href="/codes"
                                                                       className="btn btn-success waves-effect waves-light">
                                                                        <i className="fa fa-arrow-circle-o-left"></i> Regresar
                                                                    </a>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </form>

                                                <form style={{marginLeft: "-10px", marginBotton: "10px"}}
                                                      role="form" id="batchFileForm" method="post"
                                                      encType="multipart/form-data">
                                                    <div className="col-md-4">
                                                        <input type="hidden" id="_token" name="_token"
                                                               value={csrf_token}
                                                               onChange={this.handleChange}/>
                                                        <label htmlFor="batchFile">Archivo</label>
                                                        <input type="file" className="form-control" id="batchFile"
                                                               name="batchFile"/>
                                                    </div>
                                                </form>

                                            </div>
                                        }
                                        <br/>
                                        {
                                            this.state.uploadType !== 0 && this.state.loading === false &&
                                            <button type="button" className="btn btn-purple waves-effect waves-light"
                                                    id="codesRegisterButton" onClick={this.save}>
                                                <i className="fa fa-save"></i> Guardar
                                            </button>
                                        }

                                        {
                                            this.state.loading &&
                                            <button className="btn btn-purple waves-effect waves-light">
                                                <i className="fa fa-spinner fa-spin"></i> Guardando
                                            </button>
                                        }

                                        {
                                            this.state.successRegister &&
                                            <div>
                                                <a href="/codes" className="btn btn-success waves-effect waves-light">
                                                    <i className="fa fa-arrow-circle-o-left"></i> Regresar
                                                </a>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CodesRegister;

if (document.getElementById('codes_register-component')) {
    ReactDOM.render(<CodesRegister/>, document.getElementById('codes_register-component'));
}


// WEBPACK FOOTER //
// ./resources/assets/react/CodesRegister.jsx